// const baseUrl = 'http://192.168.0.111:5152/V1/'; // local url 
const baseUrl = 'https://api.lok8r.com/v1';
// const baseUrl = 'http://192.168.0.13:5152/v1';

 const fileUrl = 'https://d1cxq5q3lh6zs7.cloudfront.net/';

export { baseUrl, fileUrl};